"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2ResponsiveLogout = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var helpers_1 = require("../../../../common/helpers");
var bc_menu_v2_constants_1 = require("../bc-menu-v2-constants");
var BcMenuV2ResponsiveLogout = (function () {
    function BcMenuV2ResponsiveLogout(configLogout, isMobile) {
        this.configLogout = configLogout;
        this.isMobile = isMobile;
        this.render();
    }
    BcMenuV2ResponsiveLogout.prototype.render = function () {
        var isButtonLogout = document.getElementById(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LOGOUT_RESPONSIVE);
        if (!isButtonLogout) {
            this.createLogout(this.configLogout, this.isMobile);
        }
    };
    BcMenuV2ResponsiveLogout.prototype.createLogout = function (configLogout, isMobile) {
        var emElementQuit = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS],
            innerText: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ICON_QUIT,
        });
        var divElement = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            props: { id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LOGOUT_RESPONSIVE },
        });
        var buttonElement = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.BUTTON_TAG,
            classList: [common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS],
            innerText: !configLogout.text ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_CLOSE_SESION : configLogout.text,
            children: [emElementQuit],
        });
        if (document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE))) {
            var containerMore = document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE));
            this.createContentLogout(divElement, buttonElement, emElementQuit, isMobile, containerMore);
        }
        else {
            var containerLast = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2));
            this.createContentLogout(divElement, buttonElement, emElementQuit, isMobile, containerLast);
            divElement.style.height = isMobile ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N80 : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_AUTO;
            buttonElement.style.width = isMobile ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_INHERIT : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_BUTTON;
            divElement.style.display = common_constants_1.BcCommonConstants.FLEX;
        }
    };
    BcMenuV2ResponsiveLogout.prototype.createContentLogout = function (elementDiv, elementButton, elementEm, mobile, container) {
        var _this = this;
        elementDiv.append(elementButton);
        container.append(elementDiv);
        setTimeout(function () {
            elementDiv.style.position = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ABSOLUTE;
        }, 0);
        elementDiv.style.display = mobile ? common_constants_1.BcCommonConstants.FLEX : common_constants_1.BcCommonConstants.BLOCK;
        elementDiv.style.bottom = mobile ? "-".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N74, "px") : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N0;
        elementDiv.style.justifyContent = common_constants_1.BcCommonConstants.CENTER;
        elementDiv.style.width = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N100;
        elementDiv.style.padding = mobile ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N0 : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_PADDING;
        elementDiv.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_BACKGROUND_COLOR);
        elementButton.style.margin = mobile ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N16 : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N0;
        elementButton.style.height = mobile ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FIT_CONTENT : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_AUTO;
        elementEm.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
        elementButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.onEventLogout(event);
        });
    };
    return BcMenuV2ResponsiveLogout;
}());
exports.BcMenuV2ResponsiveLogout = BcMenuV2ResponsiveLogout;
